"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimezone = exports.getPositionSuggestions = exports.getPlaceInfoById = exports.getLanguageFromText = exports.getGenderFromName = exports.getCvSourceSuggestions = exports.getCompanySuggestions = exports.getCitySuggestions = exports.extractPlaceInfo = void 0;

var _api = _interopRequireWildcard(require("./api"));

var _axios = _interopRequireDefault(require("axios"));

var _tokenStorage = _interopRequireDefault(require("./lib/tokenStorage"));

var _staticData = _interopRequireDefault(require("./stores/staticData.store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var SIXTY_SECONDS = 60000;

var athenaEchoAxiosInstance = _axios["default"].create({
  timeout: SIXTY_SECONDS,
  baseURL: process.env.ATHENA_ECHO_URL ? process.env.ATHENA_ECHO_URL : process.env.REACT_APP_ATHENA_ECHO_URL,
  responseType: 'json'
});

athenaEchoAxiosInstance.interceptors.request.use(function (request) {
  request.headers.Authorization = _tokenStorage["default"].get();
  return request;
});
/**
 *
 * @param {string} placeString
 * @returns {Promise<{ place_id: string, description: string }[]>}
 */

var getCitySuggestions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(placeString) {
    var _response$data;

    var encodedPlaceString, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            encodedPlaceString = encodeURIComponent(placeString);
            _context.next = 3;
            return _api["default"].get("/api/googleplaces/autocomplete-places?input=".concat(encodedPlaceString, "&types=(cities)"))["catch"](_api.errorHandler);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.data ? response.data.data : response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCitySuggestions(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 *
 * @param {string} placeId
 * @returns {Promise<
 * {
 *  address_components:
 *  {
 *      long_name: string
 *      short_name: string
 *      types: string[]
 *  }[]
 *  formatted_address: string
 *  geometry:
 *  {
 *      bounds:
 *      {
 *          northeast:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *          southwest:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *      }
 *      location: { lat: number lng: number}
 *      location_type: string
 *      viewport:
 *      {
 *          northeast:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *          southwest:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *      }
 *  }
 *  place_id: string
 *  types: string[]
 * }>}
 */


exports.getCitySuggestions = getCitySuggestions;

var getPlaceInfoById = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(placeId) {
    var _response$data2;

    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _api["default"].get("/api/googleplaces/geocode-by-placeid?placeId=".concat(placeId))["catch"](_api.errorHandler);

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.data ? response.data.data[0] : response);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getPlaceInfoById(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 *
 * @param {{
 *  address_components:
 *  {
 *      long_name: string
 *      short_name: string
 *      types: string[]
 *  }[]
 *  formatted_address: string
 *  geometry:
 *  {
 *      bounds:
 *      {
 *          northeast:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *          southwest:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *      }
 *      location: { lat: number lng: number}
 *      location_type: string
 *      viewport:
 *      {
 *          northeast:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *          southwest:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *      }
 *  }
 *  place_id: string
 *  types: string[]
 * }} googlePlace
 * @returns { {
 *  address?: string
 *  city?: string
 *  state?: string
 *  countryId?: number
 *  invoicingRegionId?: number
 *  countryDefaultTimezoneId?: number
 *  postalCode?: string
 *  location: { latitude: number longitude: number}
 * }}
 */


exports.getPlaceInfoById = getPlaceInfoById;

var extractPlaceInfo = function extractPlaceInfo(googlePlace) {
  var address = googlePlace.address_components.filter(function (c) {
    return c.types.includes('route') || c.types.includes('street_number');
  }).map(function (c) {
    return c.long_name;
  }).reverse().join(' ');
  var countryComponent = googlePlace.address_components.find(function (c) {
    return c.types.includes('country');
  });
  var countryIsoCode = countryComponent && countryComponent.short_name;
  var city = googlePlace.address_components.find(function (c) {
    return c.types.includes('locality');
  });

  if (!city) {
    city = googlePlace.address_components.find(function (c) {
      return c.types.includes('postal_town') || c.types.includes('administrative_area_level_3') || c.types.includes('sublocality_level_1');
    });
  }

  var state = googlePlace.address_components.find(function (c) {
    return c.types.includes('administrative_area_level_1');
  });
  var postalCodeComponent = googlePlace.address_components.find(function (c) {
    return c.types.includes('postal_code');
  });

  var country = _staticData["default"].countries.find(function (c) {
    return c.isoCode2 === countryIsoCode;
  });

  var countryId = country && country.id;
  var invoicingRegionId = country && country.invoicingRegionId;
  var timezoneId = country && country.timezoneId;
  var cityName = city && city.long_name;
  var stateName = state && state.long_name;
  var postalCode = postalCodeComponent && postalCodeComponent.long_name;
  var latitude = googlePlace.geometry.location.lat;
  var longitude = googlePlace.geometry.location.lng;
  return {
    address: address || '',
    city: cityName || '',
    state: stateName || '',
    countryId: countryId || null,
    invoicingRegionId: invoicingRegionId || null,
    countryDefaultTimezoneId: timezoneId || null,
    postalCode: postalCode || '',
    location: {
      latitude: latitude,
      longitude: longitude
    }
  };
};
/**
 *
 * @param {number} latitude
 * @param {number} longitude
 * @returns {{
 *  dstOffset: number
 *  rawOffset: number
 *  timeZoneId: string
 *  timeZoneName: string
 * }}
 */


exports.extractPlaceInfo = extractPlaceInfo;

var getTimezone = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(latitude, longitude) {
    var response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _api["default"].get("api/timezone/location?latitude=".concat(latitude, "&longitude=").concat(longitude))["catch"](_api.errorHandler);

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getTimezone(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 *
 * @param {string} input
 * @returns {{ Languages: {Score: number LanguageCode: string}[] }}
 */


exports.getTimezone = getTimezone;

var getLanguageFromText = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(input) {
    var response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (input) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            _context4.next = 4;
            return athenaEchoAxiosInstance({
              method: 'post',
              url: "/athenaEcho",
              data: {
                payload: input,
                service_flag: 'dl'
              }
            })["catch"](_api.errorHandler);

          case 4:
            response = _context4.sent;
            return _context4.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getLanguageFromText(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 *
 * @param { { names: { name: string country_iso2?: string }[] } } input
 */


exports.getLanguageFromText = getLanguageFromText;

var getGenderFromName = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(input) {
    var response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _api["default"].post("/api/gender-from-name", input)["catch"](_api.errorHandler);

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getGenderFromName(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 *
 * @param {string} positionString
 * @param {number} limit
 * @returns
 */


exports.getGenderFromName = getGenderFromName;

var getPositionSuggestions = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(positionString, limit) {
    var encodedPositionString, baseUrl, response;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            encodedPositionString = encodeURIComponent(positionString);
            baseUrl = "/api/typeahead/positions?q=".concat(encodedPositionString);

            if (limit) {
              baseUrl = baseUrl + "&limit=".concat(limit);
            }

            _context6.next = 5;
            return _api["default"].get(baseUrl)["catch"](_api.errorHandler);

          case 5:
            response = _context6.sent;
            return _context6.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getPositionSuggestions(_x7, _x8) {
    return _ref6.apply(this, arguments);
  };
}();

exports.getPositionSuggestions = getPositionSuggestions;

var getCompanySuggestions = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(companyString) {
    var encodedCompanyString, response;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            encodedCompanyString = encodeURIComponent(companyString);
            _context7.next = 3;
            return _api["default"].get("/api/company/typeahead?q=".concat(encodedCompanyString))["catch"](_api.errorHandler);

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getCompanySuggestions(_x9) {
    return _ref7.apply(this, arguments);
  };
}();

exports.getCompanySuggestions = getCompanySuggestions;

var getCvSourceSuggestions = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(cvSourceString) {
    var encodedCvSourceString, response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            encodedCvSourceString = encodeURIComponent(cvSourceString);
            _context8.next = 3;
            return _api["default"].get("/api/cv-source/typeahead?q=".concat(encodedCvSourceString))["catch"](_api.errorHandler);

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getCvSourceSuggestions(_x10) {
    return _ref8.apply(this, arguments);
  };
}();

exports.getCvSourceSuggestions = getCvSourceSuggestions;